import script from "./ProjectView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectView.vue?vue&type=style&index=0&id=273be34e&scoped=true&lang=scss"
import "./ProjectView.vue?vue&type=style&index=1&id=273be34e&lang=scss"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-273be34e"]])

export default __exports__